import template from './employee_convert_linked_leave_type.html';
import tr from '../../lib/default-translator.js';

class EmployeeConvertLeaveTypeViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable();
		this.allowed_values = ko.observableArray([ko.observable('')]);
		this.new_cycle_date = ko.observable();
		this.available_leave_types = ko.observableArray();
		this.divide_leave = ko.observable(false);
		this.from_type = ko.observable();
		this.from_cycle_length = ko.observable();
		this.to_cycle_length = ko.observable();
		this.from_is_earned = ko.observable();
		this.to_is_earned = ko.observable();
		this.from_switch_type = ko.observable();
		this.to_switch_type = ko.observable();
		this.from_amount = ko.observable();
		this.to_amount = ko.observable();
		this.leave_linked_id = ko.observable();
		this.radioSelectedOptionValue = ko.observable('none');
		this.leave_obj = {};

		this.leave_type_id.subscribe((val) => {
			let leave_selected_id = val;
			for (let a = 0; a < this.leave_obj.length; a++)
			{
				if (this.leave_obj[a].leave_type_id == leave_selected_id)
				{
					this.to_amount(this.leave_obj[a].cycle_amount);
					this.to_switch_type(this.leave_obj[a].is_switch_type);
					this.to_is_earned(this.leave_obj[a].is_earned);
					this.to_cycle_length(this.leave_obj[a].cycle_length);
				}
			}
		});
	};

	close()
	{
		this.dialog.close();
	}

	async save_conversion()
	{
		let obj = {
			employee_id: this.dialog.bindings.employee_id,
			leave_linked_id: this.leave_linked_id(),
			to_leave_type_id: this.leave_type_id(),
			new_cycle_start_date: this.new_cycle_date(),
			leave_manipulation: this.radioSelectedOptionValue()
		};

		let res = await Grape.fetches.postJSON('/employee/save_conversion_leave', obj);
		if (res.status == 'OK')
		{
			Grape.alerts.alert({type: 'success', message: tr('Successfully converted leave type.'), title: tr('Success', 'Success')});
			this.dialog.close();
		}
		else if (res.status == 'ERROR')
			Grape.alerts.apiError(res);
		else if (res.error)
			Grape.alerts.alert({type: 'error', 'message': res.error, 'title': tr('Error', 'Error')});
		else
			Grape.alerts.alert({type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error')});
	};
};

class EmployeeConvertLeaveTypePage
{
	constructor(bindings)
	{
		this.viewModel = new EmployeeConvertLeaveTypeViewModel(this)
		this.bindings = bindings
	}

	async init()
	{
		try
		{
			let res = await Grape.fetches.postJSON('/leave/get_leave_type_info', { leave_linked_id: this.bindings.leave_linked_id })
			if (res.status !== 'ERROR')
			{
				this.viewModel.from_type(res[0].description)
				this.viewModel.from_cycle_length(res[0].cycle_length)
				this.viewModel.from_is_earned(res[0].is_earned)
				this.viewModel.from_switch_type(res[0].is_switch_type)
				this.viewModel.from_amount(res[0].cycle_amount)
				this.viewModel.leave_linked_id(res[0].leave_linked_id)
			}

			// set the new cycle date - to the person's current active start date
			let res_dep = await Grape.fetches.getJSON('/api/record', {
				table: 'v_all_employees_department',
				schema: 'savanna',
				limit: 1,
				filter: [
					{
						value: this.bindings.employee_id,
						operand: '=',
						field: 'employee_id',
					},
				],
			})
			if (res_dep.status !== 'ERROR')
				this.viewModel.new_cycle_date(res_dep.records[0].date_started)
			let res_leave_linked = await Grape.fetches.postJSON('/leave/get_available_linked_leave_selection', {
				employee_id: this.bindings.employee_id,
				leave_linked_id: this.bindings.leave_linked_id,
				is_earned_filter: true,
			})
			if (res_leave_linked.status !== 'ERROR')
			{
				this.viewModel.available_leave_types(res_leave_linked)
				this.leave_obj = res_leave_linked
				if (this.leave_obj.length > 0)
				{
					this.viewModel.to_amount(this.leave_obj[0].cycle_amount)
					this.viewModel.to_switch_type(this.leave_obj[0].is_switch_type)
					this.viewModel.to_is_earned(this.leave_obj[0].is_earned)
					this.viewModel.to_cycle_length(this.leave_obj[0].cycle_length)
				} else
				{
					console.error('Leave object is empty or undefined.')
				}
			} else
			{
				console.error('Error fetching leave linked data:', res_leave_linked)
			}
		} catch (error)
		{
			console.error('Error occurred while initializing:', error)
			Grape.alerts.alert({ type: 'error', title: 'Error', message: tr('Error occurred while loading data...') + error.message })
		}
	}
};

export default {
	name: 'EmployeeConvertLeaveType',
	dialog_class: EmployeeConvertLeaveTypePage,
	template: template,
	template_filename: 'translation/dialogs/employee_convert_linked_leave_type',
	provider: 'ps'
};
